export const getHeaderTitle = (...args: string[] | string[][] | (string | string[])[]) => {
  const sections = [...args.flat(), 'poinz'].filter(section => !!section);

  return sections.join(' | ');
};
